export default __webpack_public_path__ + "static/media/normalWhite.eb58e4bc.png";